import { SiteTicketUpdatesDto } from "mock-api/src/managed-receiving-global/types-v2";

export class TicketCountsSite {
  private constructor(args: ClassProperties<TicketCountsSite>) {
    this.autoApprovedReservationsCount = args.autoApprovedReservationsCount;
    this.openTicketsCount = args.openTicketsCount;
    this.siteId = args.siteId;
    this.siteName = args.siteName;
    this.totalCount = args.totalCount;
    this.unassignedTicketsCount = args.unassignedTicketsCount;
    this.yourTicketsCount = args.yourTicketsCount;
  }

  public readonly autoApprovedReservationsCount: number;
  public readonly openTicketsCount: number;
  public readonly siteId: number;
  public readonly siteName: string;
  public readonly totalCount: number;
  public readonly unassignedTicketsCount: number;
  public readonly yourTicketsCount: number;

  public static deserialize(apiModel: SiteTicketUpdatesDto): TicketCountsSite {
    return new TicketCountsSite({
      autoApprovedReservationsCount:
        apiModel.autoApprovedReservationsCount ?? 0,
      openTicketsCount: apiModel.openTicketsCount ?? 0,
      siteId: apiModel.siteId,
      siteName: apiModel.siteName,
      totalCount: apiModel.totalCount,
      unassignedTicketsCount: apiModel.unassignedTicketsCount ?? 0,
      yourTicketsCount: apiModel.yourTicketsCount,
    });
  }

  public static deserializeList(
    apiModel: SiteTicketUpdatesDto[],
  ): readonly TicketCountsSite[] {
    return apiModel.map(TicketCountsSite.deserialize);
  }
}
